/*
 * Copyright (c) 2026 Joseph Duggan. All rights reserved.
 */

import { t } from '@sidekick/copy';
import { PageHeader } from '../components/PageHeader.js';
import { OnTheDesk } from '../components/regions/OnTheDesk.js';
import { WaitingOn } from '../components/regions/WaitingOn.js';

/**
 * The Docket — what you're carrying right now.
 *
 * Next actions on the desk plus the things you're waiting on other
 * people for.
 */
export function DocketPage() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
      <PageHeader label={t.nav.docket} />

      <div style={{ flex: 1, display: 'flex', justifyContent: 'center', padding: '40px 22px' }}>
        <div
          style={{
            width: '100%',
            maxWidth: 620,
            display: 'flex',
            flexDirection: 'column',
            gap: 40,
          }}
        >
          <OnTheDesk />
          <WaitingOn />
        </div>
      </div>
    </div>
  );
}
